/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcProspectusV1ProspectusJobEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_PROSPECTUS_V1_PROSPECTUS_JOB_EVENT_ENTITY_NAME = 'ixc.prospectus.v1.ProspectusJobEvent';
export const ixcProspectusV1ProspectusJobEventEntity = new schema.Entity<IxcProspectusV1ProspectusJobEvent>(IXC_PROSPECTUS_V1_PROSPECTUS_JOB_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcProspectusV1ProspectusJobEvent) => `${entity.metadata?.eventId}` });

